/**
 * Core
 */
import Vue from 'vue';
import Router from 'vue-router';

/**
 * Views
 */
import Dashboard from './views/Dashboard.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Splashscreen from './views/SplashScreen.vue';
import Users from './views/Users.vue';
import Institutions from './views/Institutions.vue';
import Offices from './views/Offices.vue';
import Services from './views/Services.vue';
import Categories from './views/Categories.vue';
import Holidays from './views/Holidays/Holidays.vue';
import HolidaysChildren from './views/Holidays/HolidaysChildren.vue';
import HolidaysPlans from './views/Holidays/HolidaysPlans.vue';
import HolidaysChildrenPlans from './views/Holidays/HolidaysChildrenPlans.vue';
import HolidaysOtherPlans from './views/Holidays/HolidaysOtherPlans.vue';
import Patients from './views/Patients.vue';
import EDocuments from './views/EDocuments/EDocuments.vue';
import EDocumentsCategory from './views/EDocuments/EDocumentsCategory.vue';
import Visits from './views/visits/Visits.vue';
import Medical from './views/MedicalExaminations/MedicalExaminations.vue';
import ReservationListFirst from './views/ReservationList/ReservationListFirst.vue';
import ReservationListNext from './views/ReservationList/ReservationListNext.vue';
import Regulations from './views/Regulations.vue';
import WorkRules from './views/WorkRules.vue';
import SIOReports from './views/SioReports';
import WorkReports from './views/WorkReports';
import StudentsExport from './views/StudentsExport';
/**
 * Subviews
 */
import NoPermissions from './views/NoPermissions.vue';
import UserForm from './components/forms/UserForm.vue';
import InstitutionForm from './components/forms/InstitutionForm.vue';
import OfficeForm from './components/forms/OfficeForm.vue';
import CategoryForm from './components/forms/CategoryForm.vue';
import ServiceForm from './components/forms/ServiceForm.vue';
import HolidaysForm from './components/forms/HolidaysForm.vue';
import HolidaysChildrenForm from './components/forms/HolidaysChildrenForm.vue';
import HolidaysChildrenPlansForm from './components/forms/HolidaysChildrenPlansForm.vue';
import HolidaysOtherPlansForm from './components/forms/HolidaysOtherPlansForm.vue';
import HolidaysPlansForm from './components/forms/HolidaysPlansForm.vue';
import PatientsForm from './components/forms/patients/PatientsForm.vue';
import EDocumentsForm from './components/forms/EDocumentsForm.vue';
import EDocumentsCategoryForm from './components/forms/EDocumentsCategoryForm.vue';
import VisitsForm from './components/forms/Visits/VisitsForm.vue';
import MedicalForm from './components/forms/MedicalExaminationsForm.vue';
import ReservationListForm from './components/forms/ReservationListForm.vue';
import RegulationsForm from './components/forms/RegulationsForm.vue';
import WorkRulesForm from './components/forms/WorkRules/WorkRulesForm.vue';
/**
 * Helpers
 */
import SanitizeUtils from './utils/SanitizeUtils';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // eslint-disable-next-line
    { path: '/logowanie', component: Login, name: 'Logowanie', meta: { layout: 'guest' } },
    { path: '/wyloguj', component: Logout, name: 'Wyloguj', },
    { path: '/wczytywanie', component: Splashscreen, name: 'Splashscreen' },
    { path: '/', redirect: '/kokpit' },
    { path: '/kokpit', component: Dashboard, name: 'Kokpit' },
    { path: '/uzytkownicy', component: Users, name: 'Użytkownicy' },
    { path: '/uzytkownicy/nowy', component: UserForm, name: 'Dodawanie-Użytkownika' },
    { path: '/uzytkownicy/edycja/:id', component: UserForm, name: 'Edycja-Użytkownika' },
    { path: '/placowki', component: Institutions, name: 'Placówki' },
    { path: '/placowki/dodaj', component: InstitutionForm, name: 'Dodawanie-Placówki' },
    { path: '/placowki/edycja/:id', component: InstitutionForm, name: 'Edycja-Placówki' },
    { path: '/gabinety', component: Offices, name: 'Gabinety' },
    { path: '/gabinety/dodaj', component: OfficeForm, name: 'Dodawanie-Gabinetu' },
    { path: '/gabinety/edycja/:id', component: OfficeForm, name: 'Edycja-Gabinetu' },
    { path: '/kategorie', component: Categories, name: 'Kategorie' },
    { path: '/kategorie/dodaj', component: CategoryForm, name: 'Dodawanie-kategorii' },
    { path: '/kategorie/edycja/:id', component: CategoryForm, name: 'Edycja-kategorii' },
    { path: '/urlopy', component: Holidays, name: 'Urlopy' },
    { path: '/urlopy/dodaj', component: HolidaysForm, name: 'Dodawanie-urlopu' },
    { path: '/urlopy/planowany-urlop/:date', component: HolidaysForm, name: 'Dodawanie-planowanego-urlopu' },
    { path: '/urlopy/edycja/:id', component: HolidaysForm, name: 'Edycja-urlopu' },
    { path: '/urlopy-pracownikow', component: HolidaysChildren, name: 'Urlopy-pracowników' },
    { path: '/urlopy-pracownikow/edycja/:id', component: HolidaysChildrenForm, name: 'Edycja-urlopu-pracownika' },
    { path: '/plany-urlopowe', component: HolidaysPlans, name: 'Plany-urlopowe' },
    { path: '/plany-urlopowe/dodaj', component: HolidaysPlansForm, name: 'Dodawanie-planu-urlopowego' },
    { path: '/plany-urlopowe/edycja/:id', component: HolidaysPlansForm, name: 'Edycja-planu-urlopowego' },
    { path: '/plany-urlopowe-innych', component: HolidaysOtherPlans, name: 'Plany-urlopowe-innych' },
    { path: '/plany-urlopowe-innych/dodaj', component: HolidaysOtherPlansForm, name: 'Dodawanie-planu-urlopowego-innych' },
    { path: '/plany-urlopowe-innych/edycja/:id', component: HolidaysOtherPlansForm, name: 'Edycja-planu-urlopowego-innych' },
    { path: '/plany-urlopowe-pracownikow', component: HolidaysChildrenPlans, name: 'Plany-urlopowe-pracownikow' },
    { path: '/plany-urlopowe/plan-urlopowy-pracownika/:id', component: HolidaysChildrenPlansForm, name: 'Plany-urlopowe-pracownika' },
    { path: '/pacjenci', component: Patients, name: 'Pacjenci' },
    { path: '/pacjenci/nowy', component: PatientsForm, name: 'Dodawanie-pacjenta' },
    { path: '/pacjenci/edycja/:id', component: PatientsForm, name: 'Edycja-pacjenta' },
    { path: '/wizyty', component: Visits, name: 'Wizyty' },
    { path: '/wizyty/dodaj', component: VisitsForm, name: 'Dodawanie-wizyty' },
    { path: '/wizyty/dodaj/:patientID', component: VisitsForm, name: 'Dodawanie-wizyty-dla-pacjenta' },
    { path: '/wizyty/edycja/:id', component: VisitsForm, name: 'Edycja-wizyty' },
    { path: '/dokumenty-elektroniczne', component: EDocuments, name: 'Dokumenty-Elektroniczne' },
    { path: '/dokumenty-elektroniczne/nowy', component: EDocumentsForm, name: 'Dodawanie-dokumentu-elektronicznego' },
    { path: '/dokumenty-elektroniczne/edycja/:id', component: EDocumentsForm, name: 'Edycja-dokumentu-elektronicznego' },
    { path: '/kategorie-dokumentow-elektronicznych', component: EDocumentsCategory, name: 'Kategorie-dokumentow-elektronicznych' },
    { path: '/kategorie-dokumentow-elektronicznych/dodaj', component: EDocumentsCategoryForm, name: 'Dodawanie-dokumentow-elektronicznych' },
    { path: '/kategorie-dokumentow-elektronicznych/edycja/:id', component: EDocumentsCategoryForm, name: 'Edycja-dokumentow-elektronicznego' },
    { path: '/usługi', component: Services, name: 'Usługi' },
    { path: '/usługi/dodaj', component: ServiceForm, name: 'Dodawanie-usług' },
    { path: '/usługi/edycja/:id', component: ServiceForm, name: 'Edycja-usługi' },
    { path: '/reguly', component: WorkRules, name: 'Reguły-prac-pracowników' },
    { path: '/reguly/dodaj', component: WorkRulesForm, name: 'Dodanie-reguł-pracy-pracowników' },
    { path: '/reguly/edycja/:id', component: WorkRulesForm, name: 'Edycja-reguł-pracy-pracowników' },
    { path: '/badania', component: Medical, name: 'Badania' },
    { path: '/badania/dodaj', component: MedicalForm, name: 'Dodawanie-badania-lekarskiego' },
    { path: '/badania/edycja/:id', component: MedicalForm, name: 'edycja-badania' },
    { path: '/reservation_list/nowe-wizyty', component: ReservationListFirst, name: 'Nowe-wizyty' },
    { path: '/reservation_list/kontynuacje-wizyty', component: ReservationListNext, name: 'Kontynuacje-wizyty' },
    { path: '/reservation_list/detale/:id', component: ReservationListForm, name: 'detale-wizyty' },
    { path: '/report-sio', component: SIOReports, name: 'raport-sio' },
    { path: '/raporty-pracy', component: WorkReports, name: 'work-reports' },
    { path: '/export-uczniow', component: StudentsExport, name: 'students-export' },
    { path: '/regulaminy', component: Regulations, name: 'lista-regulaminów' },
    { path: '/regulaminy/dodaj', component: RegulationsForm, name: 'Dodawanie-regulaminu' },
    { path: '/regulaminy/edycja/:id', component: RegulationsForm, name: 'Edycja-regulaminu' },
    { path: '/404', component: Errors },
    { path: '/brak-uprawnien', component: NoPermissions },
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Wyloguj'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        },
        query: to.query // <-- dodaj to
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  next();
});

export default router;
